var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStodarLoadingCogsSmall03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 348.22 311.81",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#1D71B8;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:none;stroke:#1D71B8;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st5{fill:#FFFFFF;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CogSmall_00000116952871395315259470000010650240104709837703_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "CogSmall_00000111190641659787432860000005126965413346395272_",
    className: "st5",
    d: "M239.92,167.46l0.41-20.45l-17.37-4.18 c-0.98-3.65-2.35-7.15-4.08-10.43l9.94-14.86l-14.17-14.75l-15.25,9.33c-3.21-1.86-6.65-3.37-10.26-4.49l-3.48-17.53l-20.45-0.41 l-4.18,17.38c-3.65,0.97-7.15,2.35-10.43,4.08l-14.86-9.94l-14.76,14.17l9.33,15.25c-1.86,3.21-3.37,6.65-4.5,10.26l-17.53,3.47 l-0.41,20.45l17.38,4.18c0.97,3.66,2.35,7.15,4.08,10.43l-9.94,14.86l14.16,14.75l15.25-9.33c3.21,1.86,6.65,3.38,10.26,4.49 l3.47,17.53l20.45,0.42l4.18-17.38c3.66-0.98,7.15-2.36,10.43-4.08l14.85,9.93l14.75-14.16l-9.33-15.24 c1.86-3.22,3.37-6.65,4.5-10.27L239.92,167.46z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 174 155",
    to: "360 174 155",
    dur: "7s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M173.36,192.99c-20.48-0.41-36.75-17.35-36.34-37.83c0.41-20.49,17.35-36.76,37.84-36.35 c20.48,0.41,36.75,17.35,36.33,37.84C210.78,177.14,193.84,193.41,173.36,192.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CogSmallInside_00000085955464377235378220000011854433168445750155_",
    className: "st4",
    d: "M182.22,147.11 c4.86,4.48,5.17,12.05,0.68,16.92c-4.48,4.86-12.06,5.17-16.92,0.68c-4.86-4.48-5.17-12.06-0.69-16.92 C169.79,142.93,177.36,142.62,182.22,147.11z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStodarLoadingCogsSmall03);
export default __webpack_public_path__ + "static/media/Stodar_Loading_Cogs_Small-03.e2a3d4bb3eb7a5e0ac780f3f7e74c0e3.svg";
export { ForwardRef as ReactComponent };